module.exports = __webpack_public_path__ + "img/VillaLoreto_Beach.f0dba1c4.jpg";